import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { ReportOption } from 'app/core/models/report-option.model';
import { ReportAbstractOptionComponent } from 'app/shared/components/report-abstract-option/report-abstract-option.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { UserTypeOption, userTypeOptions } from 'app/core/options/user-type.opts';

export class ReportUserTypeOption implements ReportOption {
  value: string[];

  constructor(value: string[]) {
    this.value = value;
  }

  toPostData(options = { paramName: 'userType' }) {
    return { [options.paramName]: this.value };
  }
}

@Component({
  selector: 'app-report-user-type-option',
  templateUrl: './report-user-type-option.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ReportUserTypeOptionComponent),
    },
  ],
  imports: [NgSelectComponent, FormsModule]
})
export class ReportUserTypeOptionComponent extends ReportAbstractOptionComponent {
  @Input() label = 'Filter by User Type';
  @Input() multiple = true;

  userTypeOptions = userTypeOptions;

  selectedUserTypes: string[];

  public get userTypes(): UserTypeOption[] {
    return this.userTypeOptions;
  }

  protected updateInternalState(model: ReportUserTypeOption) {
    if (model) {
      this.selectedUserTypes = model.value;
    }
  }

  protected determineModelStateOnChange(): ReportUserTypeOption {
    if (this.selectedUserTypes &&
        (!Array.isArray(this.selectedUserTypes) ||
        this.selectedUserTypes.length > 0)) {
      return new ReportUserTypeOption(this.selectedUserTypes);
    } else {
      return null;
    }
  }
}